module.exports = __webpack_public_path__ + "static/media/finger_click.2c0d0747.png";